namespace GeniuzPOS.ReportMasterData {
    export interface Report_1336Row {
        Id?: string;
        ShopId?: string;
        ShopName?: string;
        DocDate?: string;
        DocNo?: string;
        GrossSales?: number;
        FullName?: string;
    }

    export namespace Report_1336Row {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopId';
        export const localTextPrefix = 'ReportMasterData.Report_1336';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopName = "ShopName",
            DocDate = "DocDate",
            DocNo = "DocNo",
            GrossSales = "GrossSales",
            FullName = "FullName"
        }
    }
}
